module.exports = __webpack_public_path__ + "img/new_user_modal_bg2.23c355a3.png";